import { IRoom } from '../../../models/Room'
import { IStore } from '../../index'

type RoomID = IRoom[keyof Pick<IRoom, 'id'>]

export function getModalCreateRoomIsOpen(state: IStore): boolean {
  return state.bookingCalendar.roomModal.createForm.isOpen
}

export function getModalUpdateRoomIsOpen(state: IStore): boolean {
  return (
    state.bookingCalendar.roomModal.updateForm.isOpen &&
    state.bookingCalendar.roomModal.updateForm.roomId !== null
  )
}

export function getUpdateModalReservationId(state: IStore) {
  return state.bookingCalendar.reservationModal.updateForm.id
}

export function getModalCreateReservationIsOpen(state: IStore) {
  return state.bookingCalendar.reservationModal.createForm.isOpen
}

export function getModalCreateReservaion(state: IStore) {
  return state.bookingCalendar.reservationModal.createForm
}

export function getModalUpdateReservationIsOpen(state: IStore) {
  return state.bookingCalendar.reservationModal.updateForm.isOpen
}

export function getModalReservationIsLoading(state: IStore) {
  return state.bookingCalendar.reservationModal.loading
}

export function getModalReservationIsSaving(state: IStore) {
  return state.bookingCalendar.reservationModal.isSaving
}

export function getModalServicesIsOpen(state: IStore) {
  return state.bookingCalendar.reservationModal.servicesModal.open
}

export function getModalCloseReservationIsOpen(state: IStore) {
  return state.bookingCalendar.reservationModal.closeModal.open
}

export function getModalConfigIsOpen(state: IStore) {
  return state.bookingCalendar.reservationModal.configModal.open
}

export function getModalServicesIsLoading(state: IStore) {
  return state.bookingCalendar.reservationModal.servicesModal.isLoading
}

export function getRoomIdFromOpenModal(state: IStore) {
  return state.bookingCalendar.roomModal.updateForm.roomId
}

export function getRoomModalIsSaving(state: IStore) {
  return state.bookingCalendar.roomModal.isSaving
}

export function getModalDeleteReservationIsOpen(state: IStore) {
  return state.bookingCalendar.deleteReservationModal.isOpen
}

export function getDeleteModalReservationId(state: IStore) {
  return state.bookingCalendar.deleteReservationModal.id
}
